import { currentUserShowSuccess } from '../../ducks/user.duck';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';

// Services (Tillval / Tjänster) are stored on the seller's own profile
// publicData — mirroring how the Adresser (warehouse) tab was originally meant
// to work (sdk.currentUser.updateProfile). No separate backend/collection.
// The checkout reads the listing author's profile publicData to surface them.

// ================ Action types ================ //

export const SAVE_SERVICES_REQUEST = 'app/ManageServicesPage/SAVE_SERVICES_REQUEST';
export const SAVE_SERVICES_SUCCESS = 'app/ManageServicesPage/SAVE_SERVICES_SUCCESS';
export const SAVE_SERVICES_ERROR = 'app/ManageServicesPage/SAVE_SERVICES_ERROR';

// ================ Reducer ================ //

const initialState = {
  saveInProgress: false,
  // id of the service currently being toggled/saved (for per-card UI state)
  saveInProgressId: null,
  saveError: null,
};

const manageServicesPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SAVE_SERVICES_REQUEST:
      return { ...state, saveInProgress: true, saveInProgressId: payload || null, saveError: null };
    case SAVE_SERVICES_SUCCESS:
      return { ...state, saveInProgress: false, saveInProgressId: null };
    case SAVE_SERVICES_ERROR:
      return { ...state, saveInProgress: false, saveInProgressId: null, saveError: payload };
    default:
      return state;
  }
};

export default manageServicesPageReducer;

// ================ Action creators ================ //

export const saveServicesRequest = id => ({ type: SAVE_SERVICES_REQUEST, payload: id });
export const saveServicesSuccess = () => ({ type: SAVE_SERVICES_SUCCESS });
export const saveServicesError = error => ({ type: SAVE_SERVICES_ERROR, payload: error });

// ================ Helpers ================ //

const readServices = getState =>
  getState().user.currentUser?.attributes?.profile?.publicData?.services || [];

// ================ Thunks ================ //

// Persist the full services array onto the current user's profile publicData.
const persistServices = (services, inProgressId) => (dispatch, getState, sdk) => {
  dispatch(saveServicesRequest(inProgressId));
  return sdk.currentUser
    .updateProfile({ publicData: { services } }, { expand: true })
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length === 1) {
        // Refresh state.user.currentUser so the tab re-renders with new data.
        dispatch(currentUserShowSuccess(entities[0]));
      }
      dispatch(saveServicesSuccess());
    })
    .catch(e => {
      console.error('Save services failed', e);
      dispatch(saveServicesError(storableError(e)));
    });
};

export const saveService = service => (dispatch, getState) => {
  const services = readServices(getState);
  const exists = services.some(s => s.id === service.id);
  const next = exists
    ? services.map(s => (s.id === service.id ? service : s))
    : [...services, service];
  return dispatch(persistServices(next));
};

export const deleteService = ({ id }) => (dispatch, getState) => {
  const services = readServices(getState);
  return dispatch(persistServices(services.filter(s => s.id !== id), id));
};

export const setServicePaused = ({ id, isPaused }) => (dispatch, getState) => {
  const services = readServices(getState);
  const next = services.map(s => (s.id === id ? { ...s, isPaused } : s));
  return dispatch(persistServices(next, id));
};
